import { ZButton } from "@/shared/components/button";
import { Link } from "react-router-dom";

export interface IntegrationCardProps {
  logo: string;
  logoAlt: string;
  name: string;
  description: string;
  connected: boolean;
  /** e.g. "john@example.com" or "Jira site name" */
  connectedLabel?: string;
  manageHref: string;
  onConnect: () => void;
  onDisconnect?: () => void;
  isDisconnectPending?: boolean;
}

export default function IntegrationCard({
  logo,
  logoAlt,
  name,
  description,
  connected,
  connectedLabel,
  manageHref,
  onConnect,
  onDisconnect,
  isDisconnectPending = false,
}: IntegrationCardProps) {
  return (
    <div className="flex flex-col p-5 rounded-xl border border-[#E4E4E7] bg-[#FAFAFA] min-h-[220px]">
      <div className="flex items-center gap-3">
        <img src={logo} alt={logoAlt} className="w-12 h-12 rounded-lg object-contain shrink-0" />
        <span className="font-medium text-[#171717]">{name}</span>
      </div>
      <p className="mt-3 text-sm text-[#777780] flex-1 line-clamp-2">{description}</p>
      {connected && connectedLabel && (
        <p className="mt-2 text-sm text-[#717179]">Connected as: {connectedLabel}</p>
      )}
      <div className="mt-4 flex items-center gap-2">
        {connected ? (
          <>
            <Link to={manageHref}>
              <ZButton color="default" variant="bordered" size="sm">
                Manage
              </ZButton>
            </Link>
            <ZButton
              color="default"
              variant="bordered"
              size="sm"
              isDisabled={isDisconnectPending}
              isLoading={isDisconnectPending}
              onClick={onDisconnect}
            >
              Disconnect
            </ZButton>
          </>
        ) : (
          <ZButton color="primary" size="sm" onClick={onConnect}>
            Connect
          </ZButton>
        )}
      </div>
    </div>
  );
}
